import { IComponentOptions } from "angular";
import { take } from "rxjs";
import { NewHomeExperienceService } from "@webapp/home/services/new-home-experience.service";

class HomeDashboardContainerCtrl {
  public newDashboardEnabled: boolean;
  public oldDashboardEnabled: boolean;

  public static $inject = ["NewHomeExperienceService"];

  constructor(private newHomeExperienceService: NewHomeExperienceService) {
    this.newHomeExperienceService
      .isNewHomeDashboardEnabled$()
      .pipe(take(1))
      .subscribe((newDashboardEnabled) => {
        this.newDashboardEnabled = newDashboardEnabled;
        this.oldDashboardEnabled = !newDashboardEnabled;
      });
  }
}

export const HomeDashboardContainerComponent: IComponentOptions = {
  controller: HomeDashboardContainerCtrl,
  template: require("./home-dashboard-container.component.html"),
};
